import { render, staticRenderFns } from "./orderConfiguration.vue?vue&type=template&id=532123fa&scoped=true&"
import script from "./orderConfiguration.vue?vue&type=script&lang=js&"
export * from "./orderConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./orderConfiguration.vue?vue&type=style&index=0&id=532123fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532123fa",
  null
  
)

export default component.exports